import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { ROUTE_CONSTANT } from "../routes/constant";

export const getAuthToken = () => {
  const authToken = localStorage.getItem("auth-token");
  if (!authToken || authToken === "null" || authToken === "undefined") {
    return null;
  }
  return `Bearer ${authToken}`;
};

export const setAuthToken = (authToken) => {
  localStorage.setItem("auth-token", authToken.token);
  localStorage.setItem("admin-details", JSON.stringify(authToken.adminData));
};

export const isTokenValid = (token) => {
  if (!token) return false;

  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decodedToken.exp > currentTime;
  } catch (error) {
    return false;
  }
};

export const handleApiError = (error, navigate) => {
  if (error.response) {
    const { status, data } = error.response;
    // Use a unique toastId based on status and message to prevent duplicate toasts
    const toastId = `error-${status}-${data?.message || 'default'}`;

    switch (status) {
      case 400:
        toast.error(data?.errors?.[0]?.errors?.[0] ?? data?.message ?? "Bad Request", { toastId });
        break;
      case 401:
        toast.error(data.message || "Unauthorized. Please log in again.", { toastId });
        // Only clear token and redirect if navigate is explicitly provided
        // This prevents accidental logouts when navigate is not passed
        if (navigate) {
          localStorage.removeItem("auth-token");
          localStorage.removeItem("admin-details");
          navigate(ROUTE_CONSTANT.AUTH.LOGIN);
        }
        break;
      case 403:
        toast.error(data.message || "Forbidden. You do not have permission.", { toastId });
        break;
      case 404:
        toast.error(data.message || "Resource Not Found", { toastId });
        break;
      case 408:
        toast.error(data.message || "Request Timeout", { toastId });
        break;
      case 429:
        toast.error(
          data.message || "Too Many Requests. Please try again later.",
          { toastId }
        );
        break;
      case 500:
        toast.error(
          data.message || "Internal Server Error. Please try again later.",
          { toastId }
        );
        break;
      case 502:
        toast.error(data.message || "Bad Gateway. Please try again later.", { toastId });
        break;
      case 503:
        toast.error(
          data.message || "Service Unavailable. Please try again later.",
          { toastId }
        );
        break;
      case 504:
        toast.error(data.message || "Gateway Timeout. Please try again later.", { toastId });
        break;
      default:
        toast.error(
          data.message ||
            "An unexpected error occurred. Please try again later.",
          { toastId }
        );
        break;
    }

    return data;
  } else if (error.request) {
    toast.error(
      "No Response Received from the Server. Please Check your Internet Connection and try again.",
      { toastId: "error-no-response" }
    );
    console.error("Error Request Data:", error.request);
  } else if (axios.isCancel(error)) {
    toast.info("Request canceled", { toastId: "info-request-canceled" });
    console.error("Request Canceled:", error.message);
  } else {
    toast.error(
      error.message || "An error occurred while setting up the request.",
      { toastId: `error-setup-${error.message || 'default'}` }
    );
  }

  return null;
};
